import { makeStyles } from '@mui/styles';

const useCommonStyles = makeStyles((theme) => ({
    mainContent: {
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark[800] : theme.palette.primary.light,
        width: '100%',
        flexGrow: 1,
        padding: '20px',
        marginRight: '20px',
        borderRadius: '12px'
    },
    stickyCloseBtn: {
        position: 'fixed',
        top: '0px',
        left: 'calc(10% - 40px)'
    },
    sideNavCloseBtn: {
        backgroundColor: theme.palette.background.paper,
        padding: '8px',
        paddingBottom: '4px',
        cursor: 'pointer'
    },
    primaryBackground: {
        backgroundColor: `${theme.palette.mode === 'dark' ? theme.palette.dark[800] : theme.palette.primary.light} !important`
    }
}));

export default useCommonStyles;
